import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

/** Layout-route wrapper around everything under /practice/provider except
 * the onboarding wizard itself. Reads the one derived boolean already
 * loaded on `me` (no extra fetch) — if onboarding isn't complete, redirects
 * to the wizard instead of rendering the dashboard or any of its sibling
 * routes. Any future route added under /practice/provider/* that's nested
 * inside this wrapper inherits the gate automatically. */
export function ProviderOnboardingGate() {
  const { me } = useAuth()
  if (!me?.provider_onboarding_complete) return <Navigate to="onboarding" replace />
  return <Outlet />
}
